(function() {
    angular
        .module("app")
        .controller("GenericConfirmationModalController", GenericConfirmationModalController)

    GenericConfirmationModalController.$inject = [
        "$rootScope",
        "$scope",
        "$uibModalInstance",
        "title",
        "question",
        "warning",
        "buttonLabel",
        "performAction"
    ]

    function GenericConfirmationModalController(
        $rootScope,
        $scope,
        $uibModalInstance,
        title,
        question,
        warning,
        buttonLabel,
        performAction
    ){
        "use strict"

        $scope.title       = title
        $scope.question    = question
        $scope.warning     = warning
        $scope.buttonLabel = buttonLabel

        $scope.cancel = () => {
            $uibModalInstance.dismiss("cancel")
        }

        $scope.performAction = () => {
            $uibModalInstance.close(performAction())
        }
    }
})()
